// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_GOBLINS = [{
  id: 'goblins_bridge',
  factionId: FACTIONS.GOBLINS,
  name: 'Подлый диверсант',
  priceNumens: 6000,
  skinRank: 1,
}, {
  id: 'goblins_rat',
  factionId: FACTIONS.GOBLINS,
  name: 'Отравитель колодцев',
  priceNumens: 23000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'goblins_miner',
  factionId: FACTIONS.GOBLINS,
  name: 'Осадный инженер',
  priceNumens: 68000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'goblins_gold_legacy',
  factionId: FACTIONS.GOBLINS,
  name: 'Мастер капканов',
  priceNumens: 70000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'goblins_ruby_legacy',
  factionId: FACTIONS.GOBLINS,
  name: 'Бич крепостей',
  priceCrystals: 350,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
